module.exports = __webpack_public_path__ + "img/raab_coaching_inspires_white.aedc45ce.svg";